<div [attr.id]="titleId">
    <h2 class='hvac-accordian-title' *ngIf="title" [innerHtml]="title | richText"></h2>
    <div [ngClass]="{'inline-accordian-list': colourTheme === true }" class='hvac-accordian-list-body'>
        <hvac-accordian [ngClass]="{'inline-accordian': colourTheme === true }" [colourTheme]="colourTheme" [inList]="true" *ngFor="let item of contentList" [data]="item"></hvac-accordian>
    </div>
</div>
